import { mapMutations, mapState } from 'vuex'
import * as api from './fullYearCompute-api.js'
import { deepCopy } from '@/untils/untils.js'
import SeriesLine from '@/components/echarts/seriesLine-muti-new'
import BarLoading from '@/components/echarts/bar-loading'
export default {
  components: { SeriesLine, BarLoading },
  data() {
    return {

      // 可导出单点数据的人员列表
      downloadUserList: window.DOWNLOAD_USER_LIST || [],
      
      something: '',

      // 上传
      uploadFile: '',
      formData: '',
      filePath: '',
      chartData: {},
      chartData1: {},
      SCOP: '',
      /* 说明 */
      explain: [
        {
          content: [  
            '1、选择文件: 选择8760h的冷负荷和室外湿球温度，文件格式需要符合要求,需要:"下载模板"后填写,上传文件后,:"冷负荷、湿球温度图"会对应显示曲线。',
            '2、"计算": 选择文件后,点击:"计算",会根据计算进程,显示:"计算中"、:"计算完成"。',
            '3、"全部": 当:"计算完成"后,选择计算文件,点击:"查看",:"SCOP和总功率"会对应显示曲线；点击:"下载",会输出全年8760h的计算结果。',
          ]
        },
      ],
    }
  },

  computed: {
    ...mapState({
      inputParams: s => s.inputParams,
      fileList: s => s.fileList,
      loadingStart: s => s.loadingStart
    })
  },

  inject: ['changePageNo'],


  mounted() {
    this.loadChartDataHandler()
  },

  methods: {

    ...mapMutations(['FILE_LIST', 'INPUT_PARAMS_LOAD_8760_DATA', 'LOADING_START']),

    /* api */
    calculate() { // 计算
      this.LOADING_START ({ startFlag: true, status: true })
      api.multi_points_cal(this.inputParams).then(data => {
        let r = data.data
        if (r.status == 'success') {
          let d = r.calculation_results

          this.recordLoginInfo()
          
          this.LOADING_START ({ startFlag: false, status: true })

          // 计算 - 右边图形
          const dataList = []
          Object.keys(d).map(key => {
            if (key !== 'download_path') {

              let unit = key == 'Pe_Total' ? 'kW': ''

              let data = d[key].map((t, i) => [i, t.toFixed(2), unit])

              dataList.push({
                name: key == 'Pe_Total' ? '总功率': key,
                data,
              })
            }
          })
          const dateArr = this.getDateHours()
          const axisData = dateArr

          // 全年SCOP
          let sum1 = this.chartData.dataList[1].data.reduce((pre, cur, i) => {
            if (i === 1) {
              return +pre[1] + +cur[1]
            }
            return pre + +cur[1]
          })
          let sum2 = dataList[1].data.reduce((pre, cur, i) => {
            if (i === 1) {
              return +pre[1] + +cur[1]
            }
            return pre + +cur[1]
          })

          // 存入数据
          let { download_path: path } = d
          let o = { 
            filePath: path, 
            name: path.split('/')[2], 
            data: { dataList, axisData, yAxisName: ['SCOP', '(单位/kW)'] },
            SCOP: (sum1 / sum2).toFixed(2)
          }
          let dl = deepCopy(this.fileList)
          dl.push(o)
          this.FILE_LIST(dl)
        } else {
          this.LOADING_START ({ startFlag: false, status: false })

          let html = r.warnings.join('</br>')
          html += '</br>*根据错误提示修改无错误之后，重新点计算按钮进行计算'
          this.$alert(html, '警告', {
            confirmButtonText: '确定',
            dangerouslyUseHTMLString: true,
          });
        }
      })
    },

    // 数据库 - 记录计算次数
    recordLoginInfo () {
      this.$axios.post( window.LOGIN_API + '/A98SpecialAction/recordLoginInfo', {action: '逐时计算'} )
    },
    
    /* handle */
    // 上传
    uploadHandle(params) {
      this.chartData = {}

      let reader = new FileReader()

      reader.readAsText(params.file)

      reader.onload = () => {
        const data = reader.result  // reader.result为获取结果
        const dataList = [this.handleReadData(data, 1, "湿球温度/℃", "℃", true), this.handleReadData(data, 2, "冷负荷/kW", "kW", true)]
        // const axisData = data.split(/[(\r\n)\r\n]+/).slice(2).map((item, index) => index + 1)

        console.log(dataList)
        if (!dataList) return // 如果数据有空值
        const dateArr = this.getDateHours()
        const axisData = data.split(/[(\r\n)\r\n]+/).slice(2).map((item, index) => dateArr[index])
        this.chartData = { dataList, axisData }

        // 上传后 - 存入数据
        let loadData = dataList[0].data.map((t, i) => dataList[1].data[i][1] + ',' + t[1])
        loadData = loadData.join('\n') + '\n'
        this.INPUT_PARAMS_LOAD_8760_DATA(loadData)
        this.$message({message: '导入数据成功', type: 'success'})
      }
      const formdata = new FormData()
      const file = params.file

      let uploadingTime = new Date().getTime()

      let o = this.inputParams

      formdata.append('file', file)
      formdata.append('chiller_config', JSON.stringify(o))
      formdata.append('uploadingTime', uploadingTime)

      this.formData = formdata
      this.uploadFile = params.file.name
    },

    downloadTemplete () { // 下载模板
      let a = document.createElement('a')
      a.href = '/json/8760输入文件模板_V1.0.csv'
      a.click()
    },
    // 进入页面直接渲染图表
    loadChartDataHandler () {

      const data = this.inputParams['Load_8760_Data']
      const dataList = [this.handleReadData(data, 1, "湿球温度/℃", "℃"), this.handleReadData(data, 2, "冷负荷/kW", "kW")]

      if (!dataList) return // 如果数据有空值

      const dateArr = this.getDateHours()
      const axisData = dateArr
      this.chartData = { dataList, axisData }

    },
    // 上传清空
    cancelUpload() {
      this.formData = ''
      this.uploadFile = ''
    },
    // 下载
    downloadFile() {
      if (!this.filePath) return this.$message.warning('请选择需要下载的文件')
      let a = document.createElement('a')
      a.href = window.API + this.filePath
      a.click()
    },
    // 跳转
    routerTo(o) {
      let { menuName, menuIdx, path } = o
      this.$router.push(path)
      this.changePageNo(menuName, menuIdx)
    },
    // 查看
    viewFile() {
      // axios.get(window.API + this.filePath).then(data => {
      //   // axios.get('/json/2021-06-17-13-33-23.csv').then(data => {
      //   if (data) {
      //     const dataList = [this.handleData(data, 1, "", "SCOP").data, this.handleData(data, 2, "kW", "总功率/kW").data]

      //     const dateArr = this.getDateHours()
      //     const axisData = data.data.split(/[(\r\n)\r\n]+/).slice(2).map((item, index) => dateArr[index])
      //     // const axisData = data.data.split(/[(\r\n)\r\n]+/).slice(2).map((item, index) => dateArr[index])
      //     this.chartData1 = { dataList, axisData, yAxisName: ['', '(单位/kW)'] }
      //     this.SCOP = (this.handleData(data, 3, "", "℃").sum / this.handleData(data, 2, "", "℃").sum).toFixed(2)
      //   }
      // })

      this.chartData1 = {}
      setTimeout(() => {
        let idx = this.fileList.findIndex(t => t.filePath == this.filePath)
        if (~idx) {
          let {
            data,
            SCOP,
          } = this.fileList[idx]
          this.chartData1 = data
          this.SCOP = SCOP
        }
      }, 1000)

    },
    handleData(data, idx, unit, name) {   // idx 1 是 数据最后一列 
      const dataArr = data.data.split(/[(\r\n)\r\n]+/)
      
      dataArr.pop()
      const nameArr = dataArr.splice(0, 1)[0].split(',')
      let sum = 0
      const myData = dataArr.map((item, index) => {
        const itemArr = item.split(',')
        sum += +itemArr[itemArr.length - idx]
        let d = parseFloat(itemArr[itemArr.length - idx]).toFixed(2)
        return [index, d, unit]
      })
      // const name = nameArr[nameArr.length - idx].split(' ')[1] + nameUnit
      return { data: { name, data: myData }, sum }
    },
    handleReadData(data, idx, name, unit, shiftFlag) { // idx 1 是 数据最后一列 
      const dataArr = data.split(/[(\r\n)\r\n]+/)

      if (shiftFlag) dataArr.shift()
      dataArr.pop()

      const dateArr = this.getDateHours()

      let emptyData = false

      let myData = []

      dataArr.map((item, index) => {
        if (index >= 8760) return

        const itemArr = item.split(',')

        if (itemArr[itemArr.length - idx] === '' || isNaN(itemArr[itemArr.length - idx])) {
          console.log(itemArr[itemArr.length - idx], index)
          emptyData = true
        }
        let d = parseFloat(itemArr[itemArr.length - idx]).toFixed(2)

        myData.push([dateArr[index], d, unit])
      })

      if (emptyData) {
        
        this.$message({message: '数据有空值, 请全部填写后再试', type: 'warning'})
        return false
      }

      return { name, data: myData }
    },

    getDateHours() { // 获取8760具体时间   例 1月1日 0点, 1月1日 1点 ...

      let dateArr = []

      for ( let i = 1; i <= 12; i++ ) { // 月份
        let year = new Date().getFullYear()
        let dayNumber = new Date(year, i, 0).getDate()  // 获取每个月天数

        for ( let j = 1; j <= dayNumber; j++ ) {
          
          for ( let g = 0; g <= 23; g ++){
            dateArr.push(`${i}月${j}日 ${g}点`)
          }
        }
      }

      return dateArr
    },

  },
}